// NOTE: This is only usable if the app consuming FirebaseAnalytics has correctly initialized firebase.
// See: https://firebase.google.com/docs/web/setup/
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import LocalAuth from '../authentication/local-authentication';
var userDataSet = false;
var FirebaseAnalytics = /** @class */ (function () {
    function FirebaseAnalytics() {
    }
    Object.defineProperty(FirebaseAnalytics, "MODULES", {
        get: function () {
            return {
                CREDIT: 'Credit',
                FACTORING: 'Factoring',
                FUEL: 'Fuel',
                LOADS: 'TMS',
                MY_FLEET: 'My Fleet',
                RTSPRO: 'RTSPro',
                SHOPS: 'Shops',
                TRIP_MANAGEMENT: 'Trip Management',
                REGISTRATION: 'Registration',
                SPROUT: 'Sprout',
                SPROUT_FACTORING: 'SproutFactoring',
                SPROUT_CREDIT: 'SproutCredit',
                SPROUT_RYAN_TRANS: 'SproutRyanTrans',
                SPROUT_ACCOUNTING: 'SproutAccounting',
                SPROUT_PRO_TRANSPORT: 'SproutProTransport',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAnalytics, "PARAMETERS", {
        // Fields or values being tracked
        get: function () {
            return {
                ACTION: 'action',
                ADD_STOP: 'addStop',
                ALT_ROUTE_OPTIONS: 'altRouteOption',
                AUTH_TYPE: 'authType',
                AVOID_HIGHWAYS: 'avoidHighways',
                AVOID_TOLLS: 'avoidTolls',
                BRANDS: 'brands',
                CITY: 'city',
                CLIENT_ID: 'client_id',
                CONFIRMATION_EMAIL: 'confirmation_email',
                CONTACT: 'contact',
                COUNT: 'count',
                CURRENT_LOCATION: 'currentLocation',
                DATE: 'date',
                DBXREF: 'dbXref',
                DESCRIPTION: 'description',
                DESTINATION: 'destination',
                DISCOUNT: 'discount',
                DRIVER: 'driver',
                EMULATOR: 'emulator',
                EMULATOR_SHOW_PRICING: 'emulatorShowPricing',
                ENDING_LOCATION: 'ending_location',
                FEATURED_STATIONS: 'featured_stations',
                FEEDBACK: 'feedback',
                FILES_COUNT: 'files_count',
                FILE_TYPE: 'file_type',
                FUEL_TRANSACTION_ID: 'fuel_transaction_id',
                GALLONS: 'gallons',
                GET_DIRECTIONS: 'getDirections',
                HAS_FUNDING_INSTRUCTIONS: 'has_funding_instructions',
                HAS_NOTE: 'has_note',
                HIGHWAYS: 'highways',
                ID: 'Id',
                INVOICE_ID: 'invoice_id',
                INVOICE_NUMBER: 'invoice_number',
                ITEM: 'item',
                ITEM_LIST_COUNT: 'item_list_count',
                LABEL: 'label',
                FAQ_LANGUAGE: 'faq_language',
                LAT: 'lat',
                LIST_STATION_CARD: 'listStationCard',
                LNG: 'lng',
                LOAD_ID: 'load_id',
                LOAD_ID_LIST: 'load_id_list',
                LOAD_NUMBER: 'load_number',
                LOCATION_SEARCH: 'LocationSearch',
                MILEAGE: 'mileage',
                MAP_PRICES: 'mapPrices',
                MAP_STATION_MARKER: 'mapStationMarker',
                MAP_VIEW: 'mapView',
                MODULE: 'module',
                NAME: 'name',
                PAGE: 'page',
                PAYMENT_RECEIVED_DATE: 'payment_received_date',
                PHONE: 'phone',
                PLATFORM: 'platform',
                PRICE: 'price',
                PO_NUMBER: 'po_number',
                PREVIOUS_STATUS: 'previous_status',
                PURCHASE_ID: 'purchase_id',
                QUESTION: 'question',
                REVERSE_ROUTE: 'reverseRoute',
                ROUTE_END: 'routeEnd',
                ROUTE_START: 'routeStart',
                SEARCH_NAME: 'search_name',
                SEARCH_THIS_AREA: 'searchThisArea',
                SEARCH_TYPE: 'search_type',
                SEARCH_VALUE: 'searchValue',
                STATE: 'state',
                STATES: 'states',
                STARTING_LOCATION: 'starting_location',
                STATUS: 'status',
                STOP_ID: 'stop_id',
                STOPS: 'stops',
                TAB_SELECTED: 'tab_selected',
                TRAILER_NUMBER: 'trailer_number',
                TRANSACTION_DATE: 'transaction_date',
                TRANSACTION_TIME: 'transaction_time',
                TRIP_NO: 'trip_no',
                TRUCK: 'truck',
                TOTAL_LOADS: 'total_loads',
                TOTAL_AMOUNT: 'total_amount',
                TYPE: 'type',
                TYPES: 'types',
                USER_ID: 'UserID',
                USER_IP: 'userIP',
                USER_SOURCE: 'userSource',
                USER_TYPE: 'userType',
                VALUE: 'value',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAnalytics, "EVENTS", {
        // Actions the user takes
        get: function () {
            return {
                CHECK: 'check',
                CHOOSE_LIBRARY: 'choose_library',
                CHOOSE_PDF: 'choose_pdf',
                CLICK: 'click',
                CONVERT: 'convert',
                CREATE: 'create',
                DELETE: 'Delete',
                DETAILS_VIEW: 'Details_view',
                EDIT: 'edit',
                ENTER: 'enter',
                EULA_ACCEPTED: 'eula_accepted',
                /**
                 * @deprecated Use UNEXPECTED_ERROR. Error is a reserved event name by firebase and will cause an exception.
                 */
                ERROR: 'error',
                EXIT: 'exit',
                EXPORT: 'export',
                FILTER: 'filter',
                FOCUSED: 'focused',
                INSERT: 'insert',
                PAGE_VIEW: 'page_view',
                RECEIVED: 'received',
                SAVE: 'save',
                SEARCH: 'search',
                SELECT: 'select',
                SET_FAVORITE: 'set_favorite',
                SORT: 'sort',
                SUBMIT: 'submit',
                TAB_SELECTED: 'tab_selected',
                TAKE_PHOTO: 'take_photo',
                TOGGLE: 'toggle',
                UNEXPECTED_ERROR: 'unexpected_error',
                UPLOAD: 'upload',
                DISMISSED: 'dismissed',
                MATCHED: 'matched',
                UNMATCHED: 'unmatched',
                HELD_INVOICE_TRANSFERRED: 'held_invoice_transferred',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAnalytics, "LABELS", {
        get: function () {
            return {
                AGING: 'Aging',
                AMOUNT: 'Amount',
                COMPANY_INFO: 'Company Info',
                CONTACT_NAME: 'Contact Name',
                CONTACT_PHONE_NUMBER: 'Contact Phone Number',
                CREATE_LOAD: 'Create Load',
                DEBTOR: 'Debtor',
                DRIVER: 'Driver',
                DOCUMENT: 'Document',
                EXPORT: 'Export',
                HAZMAT: 'Hazmat',
                LOGOUT: 'Logout',
                PAYMENT_DATE: 'Payment Date',
                PO_NUMBER: 'PO Number',
                SETTINGS: 'Settings',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FirebaseAnalytics, "PAGES", {
        get: function () {
            return {
                FUEL_MAP_VIEW: 'fuelMapView',
                FUEL_NAV_BAR: 'fuelNavBar',
                FUEL_STATION_DETAILS: 'fuelStationDetails',
                SHOPS_MAP_VIEW: 'shopsMapView',
                HOME_PAGE: 'homepage',
                INVOICES_PAGE: 'invoicesPage',
                FAQ_PAGE: 'faqPage',
                REPORTS: 'reports',
                HISTORY_REPORT: 'historyReport',
                HELD_REPORT: 'heldReport',
                PURCHASE_REPORT: 'purchaseReport',
                PAYMENTS_REPORT: 'paymentsReport',
                RECOURSE_REPORT: 'recourseReport',
                RESERVE_REPORT: 'reserveReport',
                AGING_REPORT: 'agingReport',
                INVOICE_SEARCH_REPORT: 'invoiceSearchReport',
                BANK_ACCOUNT_SETUP: 'bankAccountSetup',
                LANDING: 'landing',
                VERIFICATION_REQUEST: 'verificationRequest',
                VERIFICATION: 'verification',
                COMPLETE_ACCOUNT: 'completeAccount',
            };
        },
        enumerable: false,
        configurable: true
    });
    FirebaseAnalytics.init = function (firebaseConfig) {
        try {
            firebase.initializeApp(firebaseConfig);
        }
        catch (error) {
            console.error('Error initializing Firebase config', JSON.stringify(error));
            throw error;
        }
    };
    FirebaseAnalytics.setCurrentScreen = function (name) {
        firebase.analytics().setCurrentScreen(name);
    };
    FirebaseAnalytics.logPageView = function (page) {
        firebase
            .analytics()
            .logEvent(FirebaseAnalytics.EVENTS.PAGE_VIEW, { module: FirebaseAnalytics.MODULES.LOADS, page: page });
    };
    FirebaseAnalytics.sendEvent = function (event, module, page, customObject) {
        if (!userDataSet) {
            var user = this.getCurrentUser();
            this.setUser(user === null || user === void 0 ? void 0 : user._id, user === null || user === void 0 ? void 0 : user.user_type);
        }
        var payload = customObject || {};
        payload['module'] = module;
        payload['page'] = page;
        firebase.analytics().logEvent(event, payload);
    };
    FirebaseAnalytics.getCurrentUser = function () {
        var currentUser = LocalAuth.getUser();
        return (Object.keys(currentUser).length === 0 ? undefined : currentUser);
    };
    FirebaseAnalytics.setUser = function (userId, userType) {
        var _a, _b;
        if (!userId) {
            return;
        }
        firebase.analytics().setUserProperties((_a = {}, _a[FirebaseAnalytics.PARAMETERS.USER_ID] = userId, _a));
        firebase.analytics().setUserId(userId);
        if (userType) {
            firebase.analytics().setUserProperties((_b = {}, _b[FirebaseAnalytics.PARAMETERS.USER_TYPE] = userType, _b));
        }
        userDataSet = true;
    };
    return FirebaseAnalytics;
}());
export default FirebaseAnalytics;
